<template>
  <carousel v-bind="settings">
    <slide v-for="advertising in advertisings" :key="advertising.id">
      <div class="carousel-body" v-html="advertising.transContent"></div>
    </slide>
  </carousel>
</template>

<script>
  import CMS from '@/model/cms'
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    components: { Carousel, Slide },
    props: {
      widget: Object
    },
    data() {
      return {
        advertisings: [],
        settings: {
          perPage: 5,
          dots: true,
          autoplay: true,
          paginationPosition: 'bottom',
          autoplayTimeout: 6000,
          loop: true
        }
      }
    },
    mounted() {
      CMS.getAdvertisingCarousel(this.widget.advertisingType)
        .then((response) => {
          this.advertisings = response.data
        })
        .catch((error) => {
          //@todo ошибки
        })
    }
  }
</script>
